import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

interface Props {
  label: string
  grow?: boolean
}

export default function Item({ label, grow, children }: React.PropsWithChildren<Props>) {
  const content = [
    <Text.Normal key="label" size="200" color="grey600" weight="semibold">
      {label}
    </Text.Normal>,
    children,
  ]

  if (!grow) return <Box gap="s8">{content}</Box>

  return (
    <Box width="s120" gap="s8">
      {content}
    </Box>
  )
}
